// Tracks whether this device has already been shown the one-time hint pointing at the
// "Maps" button on the print-maps page (see PrintMapStyleHintDialog.vue). The background
// map style is the single biggest lever on how a printed sheet looks, and the button that
// changes it is easy to miss, so we surface it once and then never again.
//
// Stored per-device in localStorage. All access is wrapped so a disabled/full/unavailable
// localStorage (private mode, quota, SSR) degrades to "already seen" on read — showing a
// hint we cannot then remember dismissing would mean showing it on every single visit,
// which is worse than never showing it at all.

export const PRINT_MAP_STYLE_HINT_SEEN_KEY = 'hiiker.printMaps.mapStyleHintSeen';

export function hasSeenPrintMapStyleHint(): boolean {
  try {
    return localStorage.getItem(PRINT_MAP_STYLE_HINT_SEEN_KEY) === 'true';
  } catch {
    return true;
  }
}

export function markPrintMapStyleHintSeen(): void {
  try {
    localStorage.setItem(PRINT_MAP_STYLE_HINT_SEEN_KEY, 'true');
  } catch {
    // localStorage unavailable (private mode / quota) — nothing we can do. Paired with
    // hasSeenPrintMapStyleHint returning true in the same situation, the hint simply
    // never shows rather than showing on repeat.
  }
}

export function shouldShowPrintMapStyleHint(): boolean {
  return !hasSeenPrintMapStyleHint();
}
